import { useState } from "react";

import { TitleBar } from "./components/TitleBar";
import { type NavView } from "./components/PrimaryNav";
import { HelpView } from "./components/HelpView";
import { SettingsView } from "./components/SettingsView";
import { TestsWorkspace } from "./components/TestsWorkspace";

export function App() {
  const [view, setView] = useState<NavView>("tests");

  return (
    <div className="app">
      <TitleBar active={view} onSelect={setView} />
      <main className="main">
        <section className="page active">
          {view === "tests" ? (
            <TestsWorkspace />
          ) : view === "settings" ? (
            <SettingsView />
          ) : (
            <HelpView />
          )}
        </section>
      </main>
    </div>
  );
}
